export class FeedColumnLookup {
    fieldName: string;
    options: string[];
}



// WEBPACK FOOTER //
// ./src/app/main/feeds/shared/models/feed-column-lookup.model.ts